import { useEffect, useState } from 'react';

export const useWindowWidth = () => {
  const [windowInnerWidth, setWindowInnerWidth] = useState<number | null>(null);

  const handleResize = () => {
    setWindowInnerWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize, false);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return windowInnerWidth;
};
